import PropTypes from 'prop-types';
import React, {
  useRef, useCallback,
} from 'react';
import './activity-feed.scss';
import Loading from '../loading';
import ActivityFeedItem from './activity-feed-item';

const ActivityFeed = ({
  activities, hasMore, loading, setOffset, limit,
}) => {
  const observer = useRef();
  const lastElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) {
        observer.current.disconnect();
      }
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setOffset((prev) => prev + limit);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore],
  );

  return (
    <div className="activity-feed-cont">
      {activities.map((feedItem, index) => (
        activities.length === index + 1 ? (
          <div key={feedItem.id} ref={lastElementRef}>
            <ActivityFeedItem feedItem={feedItem} />
          </div>
        ) : (
          <div key={feedItem.id}>
            <ActivityFeedItem feedItem={feedItem} />
          </div>
        )
      ))}
      <div>{loading && <Loading withMessage={false} />}</div>
    </div>
  );
};

ActivityFeed.propTypes = {
  activities: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  limit: PropTypes.number.isRequired,
  setOffset: PropTypes.func.isRequired,
  hasMore: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default ActivityFeed;
